<template>
  <label :for="id" class="flex items-center cursor-pointer">
    <div class="relative">
      <input
        :id="id" type="checkbox" class="sr-only" :class="{ error: error }"
        :checked="modelValue"
        @input="$emit('update:modelValue', modelValue != true)"
      />
      <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
      <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition" />
    </div>
    <div class="ml-3 text-gray-700 font-medium">
      {{ modelValue ? 'Yes' : 'No' }}
    </div>
  </label>
  <div v-if="error" class="form-error">{{ error }}</div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `checkbox-input-${uuid()}`
      },
    },
    error: String,
    modelValue: Boolean,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>


<style scoped>
/* Toggle A */
input:checked ~ .dot {
  transform: translateX(100%);
  background-color: rgb(0, 43, 86);
}
</style>
